import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalPasswordSetController(
  $scope,
  $uibModalInstance,
  accountsService,
  modalData,
  modalConstantsService
) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.passwordInfo = {};
  $scope.passwordSetSuccess = false;

  $scope.passwordSetSuccessTitle = modalConstantsService.passwordSet.changePasswordSuccess;
  $scope.doesPasswordExist = modalData.doesPasswordExist && $scope.changePassword;

  if ($scope.changePassword) {
    $scope.title = modalConstantsService.passwordSet.changePasswordMessage;
  } else {
    $scope.title = modalConstantsService.passwordSet.addPasswordMessage;
  }

  $scope.passwordErrorMessage = function(form) {
    if (
      form['passwordInfo.newPassword'].$error.required ||
      form['passwordInfo.confirmPassword'].$error.required
    ) {
      return null;
    }
    if (form['passwordInfo.confirmPassword'].$error.matchField) {
      return modalConstantsService.passwordSet.matchErrorMessage;
    }
    if (form.$pristine && $scope.error) {
      return $scope.error;
    }
    return null;
  };

  $scope.submit = function(form) {
    form.$setPristine();
    $scope.error = '';
    if (!$scope.doesPasswordExist) {
      $scope.passwordInfo.oldPassword = 'placeholder';
    }

    accountsService.beginAccountChangePassword($scope.passwordInfo).then(
      function() {
        $scope.title = modalConstantsService.default.success.title;
        $scope.passwordSetSuccess = true;
      },
      function(error) {
        let errorCode = error && error.errors && error.errors.length > 0 && error.errors[0].code;
        if (!errorCode) {
          errorCode = 0;
        }
        switch (errorCode) {
          case 2:
            $scope.error = modalConstantsService.passwordChange.tooManyRequests;
            break;
          case 7:
            $scope.error = modalConstantsService.passwordChange.invalidPassword;
            break;
          case 8:
            $scope.error = modalConstantsService.passwordChange.invalidCurrentPassword;
            break;
          case 9:
            $scope.error = modalConstantsService.passwordChange.pinLocked;
            break;
          default:
            $scope.error = modalConstantsService.default.error.body;
        }
      }
    );
  };

  $scope.dismiss = function() {
    if ($scope.passwordSetSuccess) {
      $uibModalInstance.close(true);
    } else {
      $uibModalInstance.dismiss();
    }
  };
}

accountSettingsModule.controller(
  'accountSettingsModalPasswordSetController',
  accountSettingsModalPasswordSetController
);

export default accountSettingsModalPasswordSetController;
